



















import { Component, Vue, Prop } from "vue-property-decorator";
import { Order } from "@foxone/api/src/models/defi";
import { OrderStatus } from "@foxone/api/src/models/defi";
import utils from "defi/utils";

@Component
class OrderActions extends Vue {
  @Prop() order!: Order;

  loading = false;

  get show() {
    return this.order.status === OrderStatus.UNPAID;
  }

  handlePayOrder() {
    utils.payment.requestPayOrder(this, this.order.id, () => {
      // success handler
      this.$store.dispatch("defi/user/profile/loadWealths");
      this.$emit("reload");
    });
  }

  async handleCancelOrder() {
    this.loading = true;
    await this.$api.defi.cancelOrder(this.order.id);
    this.$common.utils.helper.toast(this, {
      message: this.$t("common.cancel.success") as string,
      color: "success"
    });
    this.$emit("reload");
  }
}
export default OrderActions;
